
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos/agendamento",
      function () {
        return require("private-next-pages/servicos/agendamento.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicos/agendamento"])
      });
    }
  